var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuellaOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_527",
    "data-name": "Grupo 527",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162.678,
    height: 203.982,
    viewBox: "0 0 162.678 203.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_33",
    "data-name": "Trazado 33",
    d: "M0,88.154H162.678V-115.828H0Z",
    transform: "translate(0 115.828)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18",
    "data-name": "Grupo 18",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17",
    "data-name": "Grupo 17",
    transform: "translate(3.522 3.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32",
    "data-name": "Trazado 32",
    d: "M3.206,13.874A94.951,94.951,0,0,1,68.012-18.062C107.578-20.45,133.467,3.42,137.632,7.477M-3.007,52.015C1.207,45.046,25.892,5.639,67.77,2.106c43.347-3.651,71.6,33.726,76.147,39.932M-1.466,78.461A91.737,91.737,0,0,0,13.874,64.14c7.876-9.261,8.911-14.321,14.112-20.98C39.739,28,57.776,23.445,60.5,22.8c25.094-5.991,45.323,7.423,46.936,8.52a59.113,59.113,0,0,1,25.432,46.233c.289,17.114-8.886,24.035-5.227,39.813a45.872,45.872,0,0,0,14.45,23.1M-2.069,107.031A113.216,113.216,0,0,0,25.217,80.275C35.187,66.336,36.078,57.886,47.3,49.867a43.125,43.125,0,0,1,26.684-8.4,42.511,42.511,0,0,1,32.775,18.449c14.908,23.248-8.742,48.285,5.829,76a52.011,52.011,0,0,0,18.085,19.094M-4.212,134.074c26.129-16.827,40.94-34.2,49.682-47.116C52.5,76.552,58.6,64.5,70.3,62.946A23.1,23.1,0,0,1,92.984,74.5c3.156,6.4,1.927,14.536-5.225,27.663-15.027,27.617-41.373,49.791-63.77,65.066M3.447,155.054a248.025,248.025,0,0,0,47.225-40.432A245.536,245.536,0,0,0,73.983,84.428m69.934-28.76a88.261,88.261,0,0,1,2.77,64.133m-56.45,7.9A33.773,33.773,0,0,0,88.7,149.589a34.913,34.913,0,0,0,17.171,20.98M43.327,173.6a58.583,58.583,0,0,1,10.741-8.52c5.78-3.557,9.633-6.016,13.8-5.466,6.38.835,11.679,8.784,13.8,19.1",
    transform: "translate(4.212 18.229)",
    fill: "none",
    stroke: "#ff4700",
    strokeLinecap: "round",
    strokeWidth: 5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuellaOrange);
export default __webpack_public_path__ + "static/media/HuellaOrange.94520d1e1b165c8307e52fb24b1af8c0.svg";
export { ForwardRef as ReactComponent };